import React, {useContext} from "react";
import classnames from "classnames";
import {ReactComponent as Settings} from "../../../../../assets/images/panel/top-bar/settings.svg";
import {matchPath} from "react-router";
import routes from "../../../../routes";
import useRouter from "../../../../hooks/use-router";
import {CompanyContext} from "../../../../contexts/company";

const PanelTopbarSettings = ({disabled}) => {
    const [company] = useContext(CompanyContext);
    const {location, history} = useRouter();
    const isInSettingsView = !!matchPath(location.pathname, {
        path: [routes.panel.settings],
        exact: true,
    });

    /**
     * navigates the user to the settings view
     */
    const navigateToSettings = () => {
        if (disabled || !company) return;
        history.push(routes.panel.settings);
    }

    return (
        <>
            <div
                className={classnames('topbar-icon',
                    {'disabled': disabled || !company},
                    {'active': isInSettingsView}
                )}
                onClick={navigateToSettings}>
                <Settings/>
            </div>
        </>
    )
}

export default PanelTopbarSettings;
